import ChatTalk from './ChatTalk';

export default ChatTalk;
